import i18next from 'i18next';
import * as Yup from 'yup';

export const vpoSchema = Yup.object().shape({
  url: Yup.string().required(i18next.t('validation.subjects.nameRequired')),
});
